import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Component } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';
import * as g from 'src/app/globals';
import * as moment from 'moment';
import { RecordProperties } from '../../record-model';
import { ModuleInventoryDirection } from 'src/app/models/module-structure';
import * as accounting from 'accounting';

@Component({
  selector: 'app-input-quantity',
  templateUrl: './input-quantity.component.html',
  styleUrls: ['./input-quantity.component.less'],
})
export class InputQuantityComponent extends Field {
  itemCode = '';
  itemDescription = '';
  batchSearchValue = '';
  manSerNum = false;
  manBtchNum = false;
  binActivated = false;
  // qtyDetailsDialogVisible = false;
  serialNumbers = [];
  batchNumbers = [];
  selectedQty = 0;
  visibleBatchNumbers = [];
  binLocationData = [];
  listOfDisplayData = [];
  ModuleInventoryDirection = ModuleInventoryDirection;
  global = g;
  binLocations: any[];
  toBinLocations: any[];
  toBinLocationData: any[];
  selectedBinLocation: any;
  selectedSSCC: any;
  toBinActivated: boolean;
  toWarehouseCode: string;
  warehouseCode: string;
  numPerSale = 0;
  dialogOpened = false;

  binSearchValue = '';
  distSearchValue = '';
  binInnerSearchValue = '';

  showSuffixButton = true;

  constructor(
    public layoutService: LayoutService,
    private notificationService: NzNotificationService,
    private modalService: NzModalService,
    private message: NzMessageService,
  ) {
    super(layoutService);
  }

  ngOnInit(): void {
    if (
      this.recordModel.ObjectKey === 'ITM_OFF_LOAD_DEF' &&
      this.field.FieldName === 'U_APPROVED_QTY'
    ) {
      this.showSuffixButton = false;
    }
    super.ngOnInit();
  }

  drawerVisibleChange() {
    if (this.recordProperty.DialogVisible) {
      this.openQtyDetailsDialog();
    } else if (
      this.recordProperty.DialogVisible === false &&
      this.dialogOpened === true
    ) {
      this.drawerConfirm();
    }
  }

  openQtyDetailsDialog() {
    const dialogVisible = this.recordProperty.DialogVisible;
    if (
      dialogVisible === false ||
      dialogVisible === undefined ||
      dialogVisible === null
    ) {
      const scope = this;
      this.recordProperty.DialogVisible = false;
      setTimeout(() => {
        scope.recordProperty.DialogVisibleDrawerInitialized = false;
      }, 50);
      return;
    }

    if (
      this.recordLine.Properties.find(
        (p) =>
          p.Name ===
          this.field.AdditionalInformationParsed.UnitOfMeasurmentPropertyName, // || p.Name === 'UnitsOfMeasurment' || p.Name === 'NumInCnt'
      ) === undefined
    ) {
      this.numPerSale = 1;
    } else {
      this.numPerSale = this.recordLine.Properties.find(
        (p) =>
          p.Name ===
          this.field.AdditionalInformationParsed.UnitOfMeasurmentPropertyName, // 'UnitsOfMeasurment' || p.Name === 'NumInCnt'
      ).ValueAsObject as number;

      if (this.numPerSale.toString() === '') {
        this.numPerSale = 1;
      }
    }
    const warehouseCodeProp = this.recordLine.Properties.find(
      (prop) =>
        prop.Name ===
        this.field.AdditionalInformationParsed.WarehouseCodePropertyName, // 'WarehouseCode'
    );
    const fromWarehouseCodeProp = this.recordLine.Properties.find(
      (prop) => prop.Name === 'FromWarehouse',
    );
    this.warehouseCode = '';
    this.toWarehouseCode = '';
    if (this.recordModel.ObjectKey === 'ITM_OFF_LOAD_DEF') {
    } else {
      if (
        fromWarehouseCodeProp == null ||
        fromWarehouseCodeProp === undefined
      ) {
        this.warehouseCode = warehouseCodeProp.ValueAsObject;
      } else {
        this.warehouseCode = fromWarehouseCodeProp.ValueAsObject;
        this.toWarehouseCode = warehouseCodeProp.ValueAsObject;
      }
    }

    this.itemCode = this.recordLine.Properties.find(
      (prop) =>
        prop.Name ===
        this.field.AdditionalInformationParsed.ItemCodePropertyPropertyName, // 'ItemCode'
    ).ValueAsObject;

    const itemOffReview = this.recordLine.Properties.find(
      (prop) => prop.Name === 'U_ITEM_REVIEW_ENTRY',
    )?.ValueAsObject;

    this.itemDescription = this.recordLine.Properties.find(
      (prop) =>
        prop.Name ===
        this.field.AdditionalInformationParsed.ItemDescriptionPropertyName,
      // 'ItemDescription' ||
      // prop.Name === 'ItemName' ||
      // prop.Name == 'ItemDesc'
    ).ValueAsObject;

    const itmSerialNumber = this.recordLine.Properties.find(
      (prop) =>
        prop.Name ===
        this.field.AdditionalInformationParsed.ITMSerialNumberPropertyName, // 'ITMSerialNumber'
    ).ValueAsObject as string;

    const uomEntry = this.recordLine.Properties.find(
      (prop) =>
        prop.Name ===
        this.field.AdditionalInformationParsed.UomEntryPropertyName, // 'UoMEntry'
    ).ValueAsObject as string;

    this.layoutService
      .executeQuery(2747, {
        WarehouseCode: this.warehouseCode,
        ToWarehouseCode: this.toWarehouseCode,
      })
      .subscribe((d) => {
        this.binActivated = d[0].Value === 'Y';
        if (this.moduleStructure.module.TableName === 'OINC') {
          this.binActivated = d[0].Value = false;
        }

        if (this.toWarehouseCode !== '') {
          this.toBinActivated = d[0].ValueTo === 'Y';
          this.layoutService
            .executeQuery(2751, { WarehouseCode: this.toWarehouseCode })
            .subscribe((x: any[]) => {
              this.toBinLocations = x;
            });
        } else {
          this.toBinActivated = false;
          this.toBinLocations = [];
        }

        this.layoutService
          .executeQuery(2748, {
            ItemCode: this.itemCode,
            ItemOffReview: itemOffReview,
          })
          .subscribe((item) => {
            this.manSerNum = item[0].ManSerNum === 'Y';
            this.manBtchNum = item[0].ManBtchNum === 'Y';

            if (
              this.binActivated === false &&
              this.manSerNum === false &&
              this.manBtchNum === false
            ) {
              const scope = this;
              this.recordProperty.DialogVisible = false;
              setTimeout(() => {
                scope.recordProperty.DialogVisibleDrawerInitialized = false;
              }, 50);

              this.prepareForNothing();
            } else {
              const scope = this;
              this.recordProperty.DialogVisibleDrawerInitialized = true;
              setTimeout(() => {
                scope.recordProperty.DialogVisible = true;
              }, 10);
              this.dialogOpened = true;

              if (
                this.binActivated &&
                !this.manSerNum &&
                this.moduleStructure.module.AdditionalInformationParsed
                  .InventoryDirection === ModuleInventoryDirection.Outbound
              ) {
                this.prepareForBinActivated(
                  this.warehouseCode,
                  uomEntry,
                  itmSerialNumber,
                );
              } else if (this.manBtchNum) {
                this.prepareForBatchNumber(
                  this.warehouseCode,
                  uomEntry,
                  itmSerialNumber,
                );
              } else if (this.manSerNum) {
                this.prepareSerialNumber(itmSerialNumber, this.warehouseCode);
              } else if (
                this.binActivated &&
                this.moduleStructure.module.AdditionalInformationParsed
                  .InventoryDirection === ModuleInventoryDirection.Inbound
              ) {
                this.prepareForBinActivated(
                  this.warehouseCode,
                  uomEntry,
                  itmSerialNumber,
                );
              }

              if (
                this.binActivated &&
                this.moduleStructure.module.AdditionalInformationParsed
                  .InventoryDirection === ModuleInventoryDirection.Inbound
              ) {
                this.prepareBinLocationInbound(this.warehouseCode);
              }
            }
          });
      });
  }

  private prepareBinLocationInbound(warehouseCode: string) {
    this.layoutService
      .executeQuery(2751, { WarehouseCode: warehouseCode })
      .subscribe((d: any[]) => {
        this.binLocations = d;
      });
  }

  private prepareForBinActivated(
    warehouseCode: string,
    uomEntry: string,
    itmSerialNumber: string,
  ) {
    let LineBin = '0';
    let baseLine = '';
    let baseEntry = '';
    let baseType = '';
    let batchNumber = '';
    let queryId = 2742;
    if (
      this.moduleStructure.module.AdditionalInformationParsed
        .InventoryDirection === ModuleInventoryDirection.Inbound
    ) {
      queryId = 2752;
    } else if (this.manBtchNum) {
      queryId = 2743;
      LineBin = this.recordLine.Properties.find(
        (prop) => prop.Name === 'BinAbs', // 'ITMSerialNumber'
      ).ValueAsObject;
      if (LineBin == null || LineBin === undefined || LineBin === '') {
        LineBin = '0';
      }

      baseLine = this.recordLine.Properties.find(
        (prop) => prop.Name === 'BaseLine', // 'ITMSerialNumber'
      )?.ValueAsObject;
      if (baseLine == null || baseLine === undefined || baseLine === '') {
        baseLine = '-1';
      }

      baseEntry = this.recordLine.Properties.find(
        (prop) => prop.Name === 'BaseEntry', // 'ITMSerialNumber'
      )?.ValueAsObject;
      if (baseEntry == null || baseEntry === undefined || baseEntry === '') {
        baseEntry = '-1';
      }

      baseType = this.recordLine.Properties.find(
        (prop) => prop.Name === 'BaseType', // 'ITMSerialNumber'
      )?.ValueAsObject;
      if (baseType == null || baseType === undefined || baseType === '') {
        baseType = '-1';
      }

      batchNumber = this.recordLine.Properties.find(
        (prop) => prop.Name === 'BatchNumber', // 'ITMSerialNumber'
      )?.ValueAsObject;
      if (
        batchNumber == null ||
        batchNumber === undefined ||
        batchNumber === ''
      ) {
        batchNumber = '';
      }
    }

    this.layoutService
      .executeQuery(queryId, {
        WhsCode: warehouseCode,
        ItemCode: this.itemCode,
        UoMEntry: uomEntry,
        BinAbs: LineBin,
        BaseLine: baseLine,
        BaseEntry: baseEntry,
        BaseType: baseType,
      })
      .subscribe((e: any[]) => {
        let binLocationDataFromDB = e;
        if (batchNumber !== '') {
          // for picklist
          binLocationDataFromDB = binLocationDataFromDB.filter(
            (b) => b.DistNumber === batchNumber,
          );
        }
        const alreadySelectedBatches = JSON.parse(
          `[${itmSerialNumber}]`,
        ) as any[];

        for (const bin of binLocationDataFromDB) {
          if (this.manBtchNum) {
            const existingBin = alreadySelectedBatches.find(
              (b) =>
                b != null &&
                ((((!this.toBinActivated &&
                  b.BinLocation?.toString() === bin.AbsEntry.toString()) ||
                  (this.toBinActivated &&
                    b.FromBinLocation.toString() ===
                      bin.AbsEntry.toString())) &&
                  b.BatchNumber === bin.DistNumber) ||
                  (b.BatchNumber === bin.DistNumber &&
                    (b.BinLocation == null ||
                      b.BinLocation === undefined ||
                      b.BinLocation === ''))),
            );

            if (existingBin != null && existingBin !== undefined) {
              if (
                existingBin.BinLocation == null ||
                existingBin.BinLocation === undefined ||
                existingBin.BinLocation === ''
              ) {
                existingBin.BinLocation = bin.AbsEntry;
              }
              bin.SelectedQuantity = existingBin.Quantity / this.numPerSale;
            }
          } else {
            if (this.moduleStructure.module.ObjectType === 'oStockTransfer') {
              alreadySelectedBatches.forEach((existingBin) => {
                if (
                  existingBin.FromBinLocation.toString() ===
                  bin.AbsEntry.toString()
                ) {
                  bin['To-' + existingBin.BinLocation] = existingBin.Quantity;
                  if (bin.SelectedQuantity === undefined) {
                    bin.SelectedQuantity =
                      existingBin.Quantity / this.numPerSale;
                  } else {
                    bin.SelectedQuantity +=
                      existingBin.Quantity / this.numPerSale;
                  }
                }
              });
              /*const existingBin = alreadySelectedBatches.find(
                (b) => b.FromBinLocation.toString() === bin.AbsEntry.toString()
              );*/
            } else {
              const existingBin = alreadySelectedBatches.find(
                (b) => b.BinLocation.toString() === bin.AbsEntry.toString(),
              );

              if (existingBin != null && existingBin !== undefined) {
                bin.SelectedQuantity = existingBin.Quantity / this.numPerSale;
              }
            }
          }
        }

        this.binLocationData = binLocationDataFromDB;
        this.listOfDisplayData = binLocationDataFromDB;
      });
  }

  private prepareForNothing() {
    this.notificationService.create(
      'warning',
      this.layoutService.translate('Nothing required'),
      `<ul>
                  <li>${this.layoutService.translate(
                    'The product is not managed by serial or batch.',
                  )}</li>
                  <li>${this.layoutService.translate(
                    'Warehouse is not bin activated.',
                  )}</li>
                </ul>`,
    );
  }

  private prepareForBatchNumber(
    warehouseCode: string,
    uomEntry: string,
    itmSerialNumber: string,
  ) {
    if (
      this.moduleStructure.module.AdditionalInformationParsed
        .InventoryDirection === ModuleInventoryDirection.Inbound
    ) {
      if (
        itmSerialNumber !== null &&
        itmSerialNumber !== undefined &&
        itmSerialNumber !== ''
      ) {
        if (itmSerialNumber.startsWith(',{')) {
          itmSerialNumber = itmSerialNumber.substring(1);
        }
        const batchNumbersTemp = JSON.parse(`[${itmSerialNumber}]`);
        console.log('batchNumbersTemp', batchNumbersTemp);
        this.selectedQty = 0;
        batchNumbersTemp.forEach((bn) => {
          bn.ManufacturingDate = this.getDateObj(bn.ManufacturingDate);
          bn.AddmisionDate = this.getDateObj(bn.AddmisionDate);
          bn.ExpDate = this.getDateObj(bn.ExpDate);
          bn.Quantity = bn.Quantity / this.numPerSale;
          bn.BaseQuantity = bn.BaseQuantity;

          this.selectedQty += bn.Quantity;
        });

        this.batchNumbers = batchNumbersTemp;
      } else {
        this.batchNumbers = [];
      }
    } else {
      let baseLine = '';
      let baseEntry = '';
      let baseType = '';

      baseLine = this.recordLine.Properties.find(
        (prop) => prop.Name === 'BaseLine', // 'ITMSerialNumber'
      )?.ValueAsObject;
      if (baseLine == null || baseLine === undefined || baseLine === '') {
        baseLine = '-1';
      }

      baseEntry = this.recordLine.Properties.find(
        (prop) => prop.Name === 'BaseEntry', // 'ITMSerialNumber'
      )?.ValueAsObject;
      if (baseEntry == null || baseEntry === undefined || baseEntry === '') {
        baseEntry = '-1';
      }

      baseType = this.recordLine.Properties.find(
        (prop) => prop.Name === 'BaseType', // 'ITMSerialNumber'
      )?.ValueAsObject;
      if (baseType == null || baseType === undefined || baseType === '') {
        baseType = '-1';
      }

      this.layoutService
        .executeQuery(
          this.moduleStructure.module.AdditionalInformationParsed.ModuleApp ==
            'itm-wms-360'
            ? 2750
            : 2149,
          {
            ItemCode: this.itemCode,
            WarehouseCode: warehouseCode,
            UoMEntry: uomEntry,
            objectName: this.moduleStructure.module.Name,
            BaseLine: baseLine,
            BaseEntry: baseEntry,
            BaseType: baseType,
          },
        )
        .subscribe((batchNumbers: any[]) => {
          if (
            itmSerialNumber == null ||
            itmSerialNumber === undefined ||
            itmSerialNumber === ''
          ) {
            this.batchNumbers = batchNumbers;
          } else {
            this.batchNumbers = batchNumbers;
            const alreadySelectedBatches = JSON.parse(
              `[${itmSerialNumber}]`,
            ) as any[];
            alreadySelectedBatches.forEach((selectedBatch) => {
              const foundedBatch = this.batchNumbers.find(
                (d) => d.DistNumber === selectedBatch.BatchNumber,
              );
              if (
                foundedBatch.SelectedQty === null ||
                foundedBatch.SelectedQty === undefined
              ) {
                foundedBatch.SelectedQty = 0;
              }

              foundedBatch.SelectedQty =
                foundedBatch.SelectedQty +
                selectedBatch.Quantity / this.numPerSale;
              if (
                selectedBatch.BinLocation != null &&
                selectedBatch.BinLocation !== undefined &&
                selectedBatch.BinLocation !== ''
              ) {
                foundedBatch['To-' + selectedBatch.BinLocation] =
                  selectedBatch.Quantity;
              }

              foundedBatch.U_ITM_WMS_SSCC = selectedBatch.U_ITM_WMS_SSCC;
            });

            this.selectedQtyChanged();
          }

          this.batchSearchValue = '';
          this.visibleBatchNumbers = this.batchNumbers;
        });
    }
  }

  private prepareSerialNumber(itmSerialNumber: string, warehouseCode: string) {
    if (
      this.moduleStructure.module.AdditionalInformationParsed
        .InventoryDirection === ModuleInventoryDirection.Outbound
    ) {
      let isEmpty = false;
      let itmSerialNumberToSend = '';
      if (
        itmSerialNumber == null ||
        itmSerialNumber === '' ||
        itmSerialNumber === undefined
      ) {
        itmSerialNumber = '0';
        itmSerialNumberToSend = '0';
        isEmpty = true;
      }

      const selectedSerialNumbers = [];
      if (!itmSerialNumber.toString().includes(',')) {
        if (!itmSerialNumber.toString().includes('|')) {
          selectedSerialNumbers.push({
            AbsEntry: Number(itmSerialNumber),
          });
          itmSerialNumberToSend = itmSerialNumber;
        } else {
          selectedSerialNumbers.push({
            AbsEntry: Number(itmSerialNumber.toString().split('|')[0]),
            BinLocation: Number(itmSerialNumber.toString().split('|')[1]),
          });

          itmSerialNumberToSend = itmSerialNumber.toString().split('|')[0];
        }
      } else {
        itmSerialNumber
          .toString()
          .split(',')
          .forEach((f) => {
            if (f.includes('|')) {
              selectedSerialNumbers.push({
                AbsEntry: Number(f.split('|')[0]),
                BinLocation: Number(f.split('|')[1]),
              });
              if (itmSerialNumberToSend === '') {
                itmSerialNumberToSend = itmSerialNumber
                  .toString()
                  .split('|')[0];
              } else {
                itmSerialNumberToSend +=
                  ',' + itmSerialNumber.toString().split('|')[0];
              }
            } else {
              selectedSerialNumbers.push({
                AbsEntry: Number(f),
              });
              if (itmSerialNumberToSend === '') {
                itmSerialNumberToSend = itmSerialNumber
                  .toString()
                  .split('|')[0];
              } else {
                itmSerialNumberToSend +=
                  ',' + itmSerialNumber.toString().split('|')[0];
              }
            }
          });
      }
      this.selectedQty = 0;
      this.layoutService
        .executeQuery(2749, {
          ItemCode: this.itemCode,
          WarehouseCode: warehouseCode,
          ITMSerialNumber_vals: itmSerialNumberToSend,
        })
        .subscribe((serialNumbers: any[]) => {
          this.serialNumbers = serialNumbers;
          this.serialNumbers.forEach((sn) => {
            const selected = selectedSerialNumbers.find(
              (s) => s.AbsEntry === sn.AbsEntry,
            );
            if (selected !== null && selected !== undefined) {
              sn.Selected = true;
              sn.ToBinLocation = selected.BinLocation;
              this.selectedQty +=
                1 /
                (this.unitsOfMeasurmentProperty === undefined ||
                this.unitsOfMeasurmentProperty.ValueAsObject === 0
                  ? 1
                  : this.unitsOfMeasurmentProperty.ValueAsObject);
            }
          });
        });
    } else if (
      this.moduleStructure.module.AdditionalInformationParsed
        .InventoryDirection === ModuleInventoryDirection.Inbound
    ) {
      const quantity = this.recordProperty.ValueAsObject;
      if (
        itmSerialNumber !== null &&
        itmSerialNumber !== undefined &&
        itmSerialNumber !== ''
      ) {
        this.serialNumbers = JSON.parse(`[${itmSerialNumber}]`);
      } else {
        this.serialNumbers = [];
      }

      /*
      if (this.serialNumbers.length !== quantity) {
        while (this.serialNumbers.length < quantity) {
          this.serialNumbers.push({
            ManufacturerSerialNumber: '',
            InternalSerialNumber: '',
          });
        }

        while (this.serialNumbers.length > quantity) {
          this.serialNumbers.splice(this.serialNumbers.length - 1, 1);
        }
      }
      */
    }
  }

  formatSelectedQuantity() {
    return `${Number(this.selectedQty).toFixed(
      g.companyConfiguration.QuantityDecimal,
    )}`;
  }
  makeDrawerVisible() {
    const scope = this;
    this.recordProperty.DialogVisibleDrawerInitialized = true;
    setTimeout(() => {
      scope.recordProperty.DialogVisible = true;
    }, 10);
  }

  drawerConfirm() {
    this.dialogOpened = false;
    console.log('this.scanControl', this.scanControl);
    if (this.scanControl !== undefined) {
      this.scanControl.focus();
      this.scanControl.scrollIntoView(true);
    }

    const scope = this;
    this.recordProperty.DialogVisible = false;
    setTimeout(() => {
      scope.recordProperty.DialogVisibleDrawerInitialized = false;
    }, 50);
    const itmSerialNumber = this.recordLine.Properties.find(
      (prop) =>
        prop.Name ===
        this.field.AdditionalInformationParsed.ITMSerialNumberPropertyName, // 'ITMSerialNumber'
    );

    const quantity = this.recordLine.Properties.find(
      (prop) =>
        prop.Name === 'Quantity' ||
        prop.Name === 'UoMCountedQuantity' ||
        prop.Name === 'U_QTY' ||
        prop.Name === 'PickedQuantity',
    );

    if (this.manSerNum) {
      this.drawerConfirmSerialNumber(itmSerialNumber, quantity);
    } else if (this.binActivated) {
      if (
        this.manBtchNum &&
        this.moduleStructure.module.AdditionalInformationParsed
          .InventoryDirection === ModuleInventoryDirection.Inbound
      ) {
        this.drawerConfirmBatchNumber(itmSerialNumber, quantity);
      } else {
        this.drawerConfirmBin(itmSerialNumber, quantity);
      }
    } else if (this.manBtchNum) {
      this.drawerConfirmBatchNumber(itmSerialNumber, quantity);
    }
  }

  private drawerConfirmBin(
    itmSerialNumber: RecordProperties,
    quantity: RecordProperties,
  ) {
    let valueToSave = '';
    this.binLocationData.forEach((batch) => {
      if (this.manBtchNum) {
        if (
          batch.SelectedQuantity === undefined ||
          batch.SelectedQuantity === '' ||
          batch.SelectedQuantity === 0 ||
          Number(batch.SelectedQuantity) === 0
        ) {
          return;
        }

        const batchValue: any[] = [];
        batchValue.push({
          Quantity: batch.SelectedQuantity * this.numPerSale,
          ExpDate: batch.ExpDate,
          AddmisionDate: batch.InDate,
          ManufacturingDate: batch.MnfDate,
          BatchNumber: batch.DistNumber,
          BinLocation: '',
          FromBinLocation: batch.AbsEntry,
        });

        if (
          this.toWarehouseCode !== '' &&
          this.toWarehouseCode !== undefined &&
          this.toWarehouseCode !== null
        ) {
          batchValue[0].FromBinLocation = batch.AbsEntry;
          batchValue[0].BinLocation = '';

          const properties = Object.keys(batch);
          let firstOneGone = false;
          properties.forEach((prop) => {
            if (prop.startsWith('To-')) {
              if (batch[prop] <= 0) {
                return;
              }

              if (!firstOneGone) {
                firstOneGone = true;
                batchValue[0].BinLocation = prop.replace('To-', '');
                batchValue[0].Quantity = batch[prop] * this.numPerSale;
              } else {
                const batchTemp = {
                  Quantity: batch[prop] * this.numPerSale,
                  ExpDate: batch.ExpDate,
                  AddmisionDate: batch.InDate,
                  ManufacturingDate: batch.MnfDate,
                  BatchNumber: batch.DistNumber,
                  BinLocation: prop.replace('To-', ''),
                  FromBinLocation: batch.AbsEntry,
                };

                batchValue.push(batchTemp);
              }
            }
          });
        } else {
          batchValue[0].BinLocation = batch.AbsEntry;
        }

        const jsonToSave = JSON.stringify(batchValue);
        if (valueToSave === '') {
          valueToSave = jsonToSave.substring(1, jsonToSave.length - 1);
        } else {
          valueToSave += ',' + jsonToSave.substring(1, jsonToSave.length - 1);
        }
      } else {
        if (
          batch.SelectedQuantity === 0 ||
          batch.SelectedQuantity === undefined
        ) {
          return;
        }

        const batchValue: any[] = [];
        batchValue.push({
          Quantity: batch.SelectedQuantity * this.numPerSale,
          BinLocation: '',
          FromBinLocation: batch.AbsEntry,
        });

        if (
          this.toWarehouseCode !== '' &&
          this.toWarehouseCode !== undefined &&
          this.toWarehouseCode !== null
        ) {
          batchValue[0].FromBinLocation = batch.AbsEntry;
          batchValue[0].BinLocation = '';

          const properties = Object.keys(batch);
          let firstOneGone = false;
          properties.forEach((prop) => {
            if (prop.startsWith('To-')) {
              if (batch[prop] <= 0) {
                return;
              }

              if (!firstOneGone) {
                firstOneGone = true;
                batchValue[0].BinLocation = prop.replace('To-', '');
                batchValue[0].Quantity = batch[prop] * this.numPerSale;
              } else {
                const batchTemp = {
                  Quantity: batch[prop] * this.numPerSale,
                  BinLocation: prop.replace('To-', ''),
                  FromBinLocation: batch.AbsEntry,
                };

                batchValue.push(batchTemp);
              }
            }
          });
        } else {
          batchValue[0].BinLocation = batch.AbsEntry;
        }

        const jsonToSave = JSON.stringify(batchValue);
        if (valueToSave === '') {
          valueToSave = jsonToSave.substring(1, jsonToSave.length - 1);
        } else {
          valueToSave += ',' + jsonToSave.substring(1, jsonToSave.length - 1);
        }

        /*
        const batchValue = {
          Quantity: batch.SelectedQuantity * batch.BasePerc,
          BinLocation: batch.AbsEntry,
        };

        if (valueToSave === '') {
          valueToSave = JSON.stringify(batchValue);
        } else {
          valueToSave += ',' + JSON.stringify(batchValue);
        }
        */
      }
    });

    itmSerialNumber.ValueAsObject = valueToSave;
    const itmSerialNumberTemp = JSON.parse(`[${valueToSave}]`);

    let tempQty = 0;
    itmSerialNumberTemp.forEach((bn) => {
      tempQty += Number(bn.Quantity / this.numPerSale);
    });

    quantity.ValueAsObject = tempQty;
    if (this.recordLine.QuantityProp !== undefined) {
      this.recordLine.QuantityProp.ValueAsObject = tempQty;
    }
  }

  private drawerConfirmBatchNumber(
    itmSerialNumber: RecordProperties,
    quantity: RecordProperties,
  ) {
    let valueToSave = '';

    if (
      this.moduleStructure.module.AdditionalInformationParsed
        .InventoryDirection === ModuleInventoryDirection.Inbound
    ) {
      if (this.numPerSale.toString() === '') {
        this.numPerSale = 1;
      }
      let showExpireDateValidation = false;
      this.batchNumbers.forEach((bn) => {
        bn.ManufacturingDate = this.getDateFormatted(bn.ManufacturingDate);
        bn.AddmisionDate = this.getDateFormatted(bn.AddmisionDate);
        if (this.recordModel.ObjectKey !== 'InventoryCounting') {
          const now = new Date();
          now.setHours(0, 0, 0, 0);
          if (
            bn.ExpDate < now &&
            bn.ExpDate !== undefined &&
            bn.ExpDate !== null
          ) {
            showExpireDateValidation = true;
          }
        }
        bn.ExpDate = this.getDateFormatted(bn.ExpDate);
        bn.Quantity = bn.Quantity * this.numPerSale;
        bn.U_ITM_WMS_SSCC = bn.U_ITM_WMS_SSCC;
      });

      if (showExpireDateValidation) {
        this.notificationService.create(
          'warning',
          this.layoutService.translate('Expire Date Validation'),
          `<ul>
                      <li>${this.layoutService.translate(
                        'The Expire Date for some batch(s) in past',
                      )}</li>
                    </ul>`,
        );
      }

      valueToSave = JSON.stringify(this.batchNumbers);
      valueToSave = valueToSave.substring(1, valueToSave.length - 1);
    } else {
      let palletPercentage = 0;
      let rowPalletPercentage = 0;
      let rowLineCapacity = 0;
      let cat = this.recordModel.Categories.find(
        (cat) => cat.Id === 'Document_Lines',
      );
      let allowedQty = 0;
      let canProceed = false;
      if (
        cat != null &&
        cat !== undefined &&
        this.recordModel.ObjectKey === 'ITM_WMS_SSCC'
      ) {
        let lines = cat.Lines;
        for (let i = 0; i < lines.length; i++) {
          const lineProps = lines[i].Properties;
          let lineQty = Number(
            lineProps.find((p) => p.Name === 'Quantity').ValueAsObject,
          );
          let lineCapacity = Number(
            lineProps.find((p) => p.Name === 'PalletCapacity').ValueAsObject,
          );
          let lineMixed = lineProps.find(
            (p) => p.Name === 'InMixed',
          ).ValueAsObject;
          if (lineMixed != 'Y') {
            continue;
          }
          if (lines[i].Id === this.lineId) {
            this.batchNumbers.forEach((batch) => {
              if (batch.SelectedQty === 0 || batch.SelectedQty === undefined) {
                return;
              }

              rowPalletPercentage += batch.SelectedQty / lineCapacity;
            });
            rowLineCapacity = lineCapacity;
          } else {
            palletPercentage += lineQty / lineCapacity;
          }
        }

        if (palletPercentage + rowPalletPercentage > 1) {
          rowPalletPercentage = 1 - palletPercentage;
          allowedQty = rowLineCapacity * rowPalletPercentage;
          /*if (qtyProp.ValueAsObject == 0) {
            this.scannedQty = rowPalletPercentage * rowLineCapacity;
          } else {
            this.scannedQty =
              rowPalletPercentage * rowLineCapacity - qtyProp.ValueAsObject;
          }*/
          //return;
        } else {
          canProceed = true;
        }
      } else {
        canProceed = true;
      }

      let quantitySubmitted = 0;
      this.batchNumbers.forEach((batch) => {
        if (batch.SelectedQty === 0 || batch.SelectedQty === undefined) {
          return;
        }

        let batchValue = [];
        let confirmChoice = false;
        let confirmAppear = false;
        if (!canProceed && batch.SelectedQty + quantitySubmitted > allowedQty) {
          if (!confirmAppear) {
            confirmChoice = confirm(
              this.layoutService.translate(
                'The selected quantity exceeds the pallet size, do you want to continue?',
              ),
            );
            confirmAppear = true;
          }
          if (!confirmChoice) {
            if (allowedQty == 0) {
              batch.SelectedQty = 0;
            } else {
              if (allowedQty - quantitySubmitted < 0) {
                batch.SelectedQty = 0;
              } else {
                batch.SelectedQty = Math.floor(allowedQty - quantitySubmitted);
              }
            }

            batchValue = [
              {
                Quantity: batch.SelectedQty * this.numPerSale,
                ExpDate: batch.ExpDate,
                AddmisionDate: batch.InDate,
                ManufacturingDate: batch.MnfDate,
                BatchNumber: batch.DistNumber,
                U_ITM_WMS_SSCC: batch.U_ITM_WMS_SSCC,
                BinLocation: '',
              },
            ];
          } else {
            batchValue = [
              {
                Quantity: batch.SelectedQty * this.numPerSale,
                ExpDate: batch.ExpDate,
                AddmisionDate: batch.InDate,
                ManufacturingDate: batch.MnfDate,
                BatchNumber: batch.DistNumber,
                U_ITM_WMS_SSCC: batch.U_ITM_WMS_SSCC,
                BinLocation: '',
                BaseQuantity: batch.BasePerc,
              },
            ];
          }
        } else {
          batchValue = [
            {
              Quantity: batch.SelectedQty * this.numPerSale,
              ExpDate: batch.ExpDate,
              AddmisionDate: batch.InDate,
              ManufacturingDate: batch.MnfDate,
              BatchNumber: batch.DistNumber,
              U_ITM_WMS_SSCC: batch.U_ITM_WMS_SSCC,
              BinLocation: '',
              BaseQuantity: batch.BasePerc,
            },
          ];
        }

        quantitySubmitted += batch.SelectedQty;
        if (
          this.toWarehouseCode !== '' &&
          this.toWarehouseCode !== undefined &&
          this.toWarehouseCode !== null
        ) {
          batchValue[0].BinLocation = '';

          const properties = Object.keys(batch);
          let firstOneGone = false;
          properties.forEach((prop) => {
            if (prop.startsWith('To-')) {
              if (batch[prop] <= 0) {
                return;
              }

              if (!firstOneGone) {
                firstOneGone = true;
                batchValue[0].BinLocation = prop.replace('To-', '');
                batchValue[0].Quantity = batch[prop] * this.numPerSale;
              } else {
                const batchTemp = {
                  Quantity: batch[prop] * this.numPerSale,
                  ExpDate: batch.ExpDate,
                  AddmisionDate: batch.InDate,
                  ManufacturingDate: batch.MnfDate,
                  BatchNumber: batch.DistNumber,
                  BinLocation: prop.replace('To-', ''),
                  U_ITM_WMS_SSCC: batch.U_ITM_WMS_SSCC,
                  FromBinLocation: batch.AbsEntry,
                };

                batchValue.push(batchTemp);
              }
            }
          });
        }

        const jsonToSave = JSON.stringify(batchValue);
        if (valueToSave === '') {
          valueToSave = jsonToSave.substring(1, jsonToSave.length - 1);
        } else {
          valueToSave += ',' + jsonToSave.substring(1, jsonToSave.length - 1);
        }
      });
    }

    itmSerialNumber.ValueAsObject = valueToSave;

    const itmSerialNumberTemp = JSON.parse(`[${valueToSave}]`);

    let tempQty = 0;
    itmSerialNumberTemp.forEach((bn) => {
      tempQty += Number(bn.Quantity / this.numPerSale);
    });

    quantity.ValueAsObject = tempQty;
    if (this.recordLine.QuantityProp !== undefined) {
      this.recordLine.QuantityProp.ValueAsObject = tempQty;
    }
  }

  private drawerConfirmSerialNumber(
    itmSerialNumber: RecordProperties,
    quantity: RecordProperties,
  ) {
    if (
      this.moduleStructure.module.AdditionalInformationParsed
        .InventoryDirection === ModuleInventoryDirection.Outbound
    ) {
      let serialNumbersToSave = '';
      quantity.ValueAsObject = 0;
      this.serialNumbers.forEach((sn) => {
        if (!sn.Selected) {
          return;
        }
        if (serialNumbersToSave === '') {
          serialNumbersToSave = sn.AbsEntry;
        } else {
          serialNumbersToSave += ',' + sn.AbsEntry;
        }

        if (
          sn.ToBinLocation !== null &&
          sn.ToBinLocation !== undefined &&
          !Number.isNaN(sn.ToBinLocation)
        ) {
          serialNumbersToSave += '|' + sn.ToBinLocation;
        }
        quantity.ValueAsObject +=
          1 /
          (this.unitsOfMeasurmentProperty === undefined
            ? 1
            : this.unitsOfMeasurmentProperty.ValueAsObject);
      });

      //quantity.ValueAsObject = this.serialNumbers.length;
      itmSerialNumber.ValueAsObject = serialNumbersToSave;
    } else if (
      this.moduleStructure.module.AdditionalInformationParsed
        .InventoryDirection === ModuleInventoryDirection.Inbound
    ) {
      const jsonToSave = JSON.stringify(this.serialNumbers);
      quantity.ValueAsObject = this.serialNumbers.length / this.numPerSale;
      itmSerialNumber.ValueAsObject = jsonToSave.substring(
        1,
        jsonToSave.length - 1,
      );
    }
  }

  selectedBinChanged() {
    this.modalService.confirm({
      nzTitle: this.layoutService.translate(
        'Do you want to change bin location for all lines, or only unallocated lines?',
      ),
      nzOkText: this.layoutService.translate('All lines'),
      nzCancelText: this.layoutService.translate('Only unallocated lines'),
      nzOnOk: () => {
        if (this.manSerNum) {
          this.serialNumbers.forEach((sn) => {
            sn.BinLocation = this.selectedBinLocation;
          });
        } else if (this.manBtchNum) {
          this.batchNumbers.forEach((bn) => {
            if (bn.BinLocation === 0 || bn.BinLocation === undefined) {
              bn.BinLocation = this.selectedBinLocation;
            }
          });
        }
      },
      nzOnCancel: () => {
        if (this.manSerNum) {
          this.serialNumbers.forEach((sn) => {
            if (sn.BinLocation === 0 || sn.BinLocation === undefined) {
              sn.BinLocation = this.selectedBinLocation;
            }
          });
        } else if (this.manBtchNum) {
          this.batchNumbers.forEach((bn) => {
            if (bn.BinLocation === 0 || bn.BinLocation === undefined) {
              bn.BinLocation = this.selectedBinLocation;
            }
          });
        }
      },
    });
  }

  searchForBatch() {
    this.visibleBatchNumbers = this.batchNumbers.filter((b) => {
      return (
        b.DistNumber.toLowerCase().indexOf(
          this.batchSearchValue.toLowerCase(),
        ) !== -1
      );
    });
  }

  selectedQtyChanged() {
    this.selectedQty = 0;
    this.batchNumbers.forEach((batch) => {
      if (
        batch.SelectedQty === 0 ||
        batch.SelectedQty === undefined ||
        batch.SelectedQty === '' ||
        Number(batch.SelectedQty) === 0
      ) {
        return;
      }

      this.selectedQty += batch.SelectedQty;
    });
  }

  toBinConfirm(bin: any) {
    console.log(bin);
    bin.QtyDetailsDialog = false;
    this.binLocationData.forEach((bin) => {
      bin.SelectedQuantity = 0;
      const properties = Object.keys(bin);
      properties.forEach((prop) => {
        if (prop.startsWith('To-')) {
          if (bin[prop] <= 0) {
            return;
          }
          bin.SelectedQuantity += bin[prop];
        }
      });
    });
    this.binQuantitySelected();
  }

  binQuantitySelected() {
    this.selectedQty = 0;
    this.binLocationData.forEach((bin) => {
      if (
        bin.SelectedQuantity === 0 ||
        bin.SelectedQuantity === undefined ||
        bin.SelectedQuantity === '' ||
        Number(bin.SelectedQuantity) === 0
      ) {
        return;
      }

      if (bin.OnHandQty < bin.SelectedQuantity) {
        this.message.error(
          this.layoutService.translate(
            'Selected quantity of bin , we reset the quantity to the maximum allowed quantity',
          ),
        );
        bin.SelectedQuantity = bin.OnHandQty;
      }
      this.selectedQty += Number(bin.SelectedQuantity);
    });
  }

  allocateToDefaultBin() {
    this.binLocationData.forEach((bin) => {
      if (bin.IsDefault === 'Y') {
        if (this.selectedQty >= this.recordProperty.ValueAsObject) {
          this.modalService.error({
            nzTitle: this.layoutService.translate(
              'You have allocated all items, do you want to reset the allocation and put everything in default bin location?',
            ),
            nzOkText: this.layoutService.translate('Yes'),
            nzCancelText: this.layoutService.translate('Cancel'),
            nzOnCancel: () => {},
            nzOnOk: () => {
              this.binLocationData.forEach((b) => {
                b.SelectedQuantity = 0;
              });
              bin.SelectedQuantity = this.recordProperty.ValueAsObject;
              this.selectedQty = this.recordProperty.ValueAsObject;
            },
          });
        } else {
          bin.SelectedQuantity =
            this.recordProperty.ValueAsObject - this.selectedQty;
          this.selectedQty = this.recordProperty.ValueAsObject;
        }
      }
    });
  }

  applySSCCToAll() {
    if (this.manSerNum) {
      this.serialNumbers.forEach(
        (sn) => (sn.U_ITM_WMS_SSCC = this.selectedSSCC),
      );
    } else if (this.manBtchNum) {
      this.batchNumbers.forEach(
        (sn) => (sn.U_ITM_WMS_SSCC = this.selectedSSCC),
      );
    }
  }

  updateFilter() {
    if (this.binSearchValue !== '') {
      this.listOfDisplayData = this.binLocationData.filter(
        (bin) => bin.BinCode.indexOf(this.binSearchValue) !== -1,
      );
    } else {
      this.listOfDisplayData = this.binLocationData;
    }

    if (this.distSearchValue !== '') {
      this.listOfDisplayData = this.listOfDisplayData.filter(
        (bin) => bin.DistNumber.indexOf(this.distSearchValue) !== -1,
      );
    }
  }

  openToBin(bin: any) {
    bin.QtyDetailsDialog = true;
    this.updateInnerFilter();
  }

  updateInnerFilter() {
    if (this.binInnerSearchValue !== '') {
      this.toBinLocationData = this.toBinLocations.filter(
        (bin) => bin.BinCode.indexOf(this.binInnerSearchValue) !== -1,
      );
    } else {
      this.toBinLocationData = this.toBinLocations;
    }
  }

  private getDateObj(date: any): Date {
    const df = g.companyConfiguration.MomentDateFormat;
    let result: Date;
    if (date === null || date === undefined || date === '') {
      result = undefined;
    } else {
      result = moment(date, df).toDate();
    }

    return result;
  }

  private getDateFormatted(date: any): string {
    const df = g.companyConfiguration.MomentDateFormat;
    let result = '';
    if (date === null || date === undefined) {
      result = '';
    } else {
      result = moment(date).format(df) as string;
    }

    return result;
  }

  formatterQuantity(value: number): string {
    if (value == null || isNaN(value)) {
      value = 0;
    }

    return accounting.formatNumber(
      value,
      g.companyConfiguration.QuantityDecimal,
      g.companyConfiguration.ThousandSep,
      g.companyConfiguration.DecimalSep,
    );
  }
}
